import { ROUTES } from '@app/constants'
import { runtimeConfig } from '@app/common/config'

export const PARENTS_URL = runtimeConfig?.PARENT_BASE_URL || 'https://parents.elemy.com/'

export const navData = [
  {
    id: 1,
    text: 'For Parents',
    path: '',
    hasChild: true
  },
  {
    id: 2,
    text: 'For ABA Clinicians',
    path: ROUTES.joinUs,
    hasChild: false
  },
  {
    id: 3,
    text: 'For Pediatricians',
    path: ROUTES.forPediatricians,
    hasChild: false
  },
  {
    id: 4,
    text: 'About Us',
    path: '',
    hasChild: true
  }
]
